<template>
  <div>
    <base-modal
      id="collateral-share-modal"
      :title="'Sharing folder &quot;' + folder.name + '&quot;'"
      :show="showCustomerSelectModal"
      :show-close-button="true"
      @closed="$emit('click')"
    >
      <base-heading>Choose your recipient</base-heading>
      <hr>
      <base-text class="pt-4 pb-2">
        Please select the recipient you will be sending the album link to.
      </base-text>
      <client-selector
        shared-link-selector
        :customers="customers"
        :selected="selectedCustomer"
        :count="customersCount"
        @select="selectCustomer"
        @on-search="onSearch"
        @reached-bottom="onBottomReached"
      />
      <template slot="footer">
        <base-button
          class="mr-0"
          inverse
          @click="onCustomerSelectClick"
        >
          <base-text>Create Link</base-text>
        </base-button>
      </template>
    </base-modal>
    <base-modal
      id="link-created-modal"
      :show="showLinkCreatedModal"
      :show-close-button="true"
      @closed="onLinkCreatedModalClosed"
      @shown="onLinkCreatedModalShown"
    >
      <base-heading>Unique link created!</base-heading>
      <hr>
      <base-text class="pt-2 pb-4">
        Your link has been copied to clipboard.
      </base-text>
      <div
        class="shared-link"
      >
        <input
          id="sharedLinkInput"
          ref="copyLinkInput"
          v-model="link"
          readonly
          type="text"
          class="form-control shared-link__input"
          @keyup.enter="onKeyUp"
        >

        <base-icon
          v-if="!copyTooltip"
          icon="appointment-link"
          class="clickable shared-link__icon"
          @click="onCopyLinkClicked"
        />

        <base-tooltip
          v-else
          text="Copied to clipboard!"
        >
          <base-icon
            icon="appointment-link"
            class="clickable shared-link__icon"
            @click="onCopyLinkClicked"
          />
        </base-tooltip>
      </div>
    </base-modal>
  </div>
</template>
<script>
import _ from 'lodash';
import { EventBus } from '@/event-bus';
import Listable from '@/components/mixins/listable';
import ClientSelector from '../ClientSelector';
import { collateralService } from '../../../_services';

export default {
  name: 'CollateralShareModal',
  components: {
    ClientSelector,
  },
  mixins: [Listable],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: 'customers',
    },
    folder: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      showCustomerSelectModal: false,
      showLinkCreatedModal: false,
      selectedCustomer: {
        first_name: '',
        last_name: '',
      },
      copyTooltip: false,
      link: '',
      testUser: {
        pk: -1,
        first_name: 'Test',
        last_name: 'User',
      },
    };
  },
  computed: {
    customers() {
      return [this.testUser, ...this.$store.state.customers.items];
    },
    customersCount() {
      return this.$store.state.customers.count;
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.selectedCustomer = {
          first_name: '',
          last_name: '',
        };
        this.link = '';
        this.startClientFetch();
      }
      this.showCustomerSelectModal = value;
    },
  },
  methods: {
    startClientFetch() {
      this.$store.dispatch('customers/customReset');
      if (this.truePage === 1) {
        this.fetchData();
      } else {
        this.truePage = 1;
      }
    },
    async onCustomerSelectClick() {
      this.$mixpanel.track('share_album', {
        account_id: this.$store.state.account.user.user.email,
        album: this.$route.params.folderId,
        customer: this.selectedCustomer.pk,
      });
      this.link = (await collateralService.getCollateralLink(this.folder.pk, this.selectedCustomer.pk)).data.link;
      this.showCustomerSelectModal = false;
      this.showLinkCreatedModal = true;
    },
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    selectCustomer(customer) {
      this.selectedCustomer = customer;
    },
    onBottomReached() {
      if (this.nextPageExists) {
        this.truePage += 1;
      }
    },
    onKeyUp() {
    },
    copyLink() {
      document.getElementById('sharedLinkInput').select();
      try {
        window.Clipboard.copy(this.link);
        document.execCommand('copy');
      } catch (e) {
        EventBus.$emit('toast-error', 'Couldn\'t copy link to clipboard, please wait a few seconds and try again.');
      }
    },
    onCopyLinkClicked() {
      this.copyLink();
      this.copyTooltip = true;
      console.log('COPIED');
      setTimeout(() => { this.copyTooltip = false; }, 2000);
    },
    onLinkCreatedModalShown() {
      this.copyLink();
    },
    onLinkCreatedModalClosed() {
      this.showLinkCreatedModal = false;
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss"
  scoped>
  ::v-deep .modal-dialog {
    max-width: 632px !important;
    max-height: 294px !important;
    .modal-content {
      .close {
        transform: scale(1.5);
        margin-right: 18px;
        margin-top: -5px;
      }
    }
  }
  ::v-deep .modal-content {
    padding: 15px;
  }
  ::v-deep .form-control {
    &[readonly] {
      background-color: transparent !important;
    }
    &::selection {
      background-color: $bone;
    }
  }
  .shared-link {
    display: flex;
    align-items: center;
    margin-right: 0.625rem;

    &__input {
      font-family: $font-family-sans-serif-light;
      padding: 0.55rem 2.7rem 0.55rem 0.8125rem ;
      border-radius: 5px;
      min-width: 100%;
    }
    &__icon{
      margin-left: -2.3rem;
    }
  }
</style>
